import type { AvitoLocationHhMappingItem } from '../../services/avitoDictionariesService';

export const DEFAULT_HH_AREA_FALLBACK_SUBTITLE =
  'Не смогли найти данную Георгафию на hh.ru. Выберите нужную локацию из списка.';

export const HH_AREA_MAPPING_ERROR_SUBTITLE =
  'Не смогли сопоставить выбранную географию с hh.ru. Выберите нужную локацию из списка.';

const MAX_VISIBLE_UNMAPPED_LOCATIONS = 6;

export function buildHhAreaFallbackSubtitle(
  unmapped: AvitoLocationHhMappingItem[] = []
): string {
  const names = Array.from(new Set(
    unmapped
      .map((item) => item.avitoLocationName || item.avitoLocationId)
      .map((value) => String(value || '').trim())
      .filter(Boolean)
  ));

  if (names.length === 0) {
    return DEFAULT_HH_AREA_FALLBACK_SUBTITLE;
  }

  const visibleNames = names.slice(0, MAX_VISIBLE_UNMAPPED_LOCATIONS);
  const hiddenCount = names.length - visibleNames.length;
  const hiddenText = hiddenCount > 0 ? ` и еще ${hiddenCount}` : '';
  const chooseText = names.length === 1 ? 'нужную локацию' : 'нужные локации';

  return `Не смогли найти географию на hh.ru: ${visibleNames.join(', ')}${hiddenText}. Выберите ${chooseText} из списка.`;
}
